import { logKnownEventForNamespace } from "@cultureamp/amplitude"

export const logKnownEvent = logKnownEventForNamespace("performance")
